import { useIsFeatureFlagEnabled } from "@circle-react/hooks/UseCommunitySetting";

import { AVATARS_V2_UI_FEATURE_FLAG } from "./useIsAvatarsV2Ui";

// Single source of truth for whether the BotBuilder edit screens (Customize/
// Audience/Behavior/Knowledge/Automations) render the Avatars v2 layout.
export const useIsAvatarsV2Layout = () =>
  useIsFeatureFlagEnabled(AVATARS_V2_UI_FEATURE_FLAG);
